import { render, staticRenderFns } from "./AddProductionStaff.vue?vue&type=template&id=4fe17248"
import script from "./AddProductionStaff.vue?vue&type=script&lang=js"
export * from "./AddProductionStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports